
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap'

const ContextMenuTitleAction = ({ headerOptions }) =>
{
	const { t } = useTranslation()
	
	return (

			<div className="btn-actions-pane-right text-capitalize actions-icon-btn">
				<UncontrolledButtonDropdown>
					<DropdownToggle className="btn-icon btn-icon-only" color="link">
						<i className="pe-7s-menu btn-icon-wrapper" />
					</DropdownToggle>
					<DropdownMenu className="dropdown-menu-right rm-pointers dropdown-menu-shadow dropdown-menu-hover-link">
						<DropdownItem header>Context Menu</DropdownItem>
						{ headerOptions.showBack &&
							<DropdownItem
								href="#"
								onClick={() => headerOptions.backCommand()}
							>
								<i className="dropdown-icon lnr-arrow-left-circle"/>
								<span>{ t('Common.Back') }</span>
							</DropdownItem>
						}
						{ headerOptions.showReload &&
							<DropdownItem
								href="#"
								onClick={() => headerOptions.reloadCommand()}
							>
								<i className="dropdown-icon lnr-sync"/>
								<span>{ t('Common.Reload') }</span>
							</DropdownItem>
						}
					</DropdownMenu>
				</UncontrolledButtonDropdown>
			</div>

	)
}

export default ContextMenuTitleAction
